import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';
import styled from 'styled-components';
import { DatePicker as AntdDatePicker } from 'antd';
import calendar_icon from 'features/ticketList/pages/ListTicketPage/icons/calendar.svg';
import dayjs, { Dayjs } from 'dayjs';
import { RangeValue } from 'rc-picker/lib/interface';
import { DATE_FORMAT } from 'features/appointment/utils/format';

type DatePickerByTypeViewProps = {
    viewType: CALENDAR_VIEW_TYPE;
    value?: { startTime?: Dayjs; endTime?: Dayjs };
    onChange?: (value: { startTime: Dayjs; endTime: Dayjs } | null) => void;
}

const { RangePicker } = AntdDatePicker;

const DatePickerByTypeView = ({ viewType, value, onChange }: DatePickerByTypeViewProps) => {
    const onChangeDate = (date: Dayjs | null) => {
        if (!date) return;
        onChange?.({ startTime: date, endTime: date });
    };

    const onChangeRange = (values: RangeValue<Dayjs> | null) => {
        if (!values || !values[0] || !values[1]) return;
        onChange?.({ startTime: values[0], endTime: values[1] });
    };

    const panelRender = (panelNode: React.ReactNode) => (
        <StyleWrapperDatePicker>
            {panelNode}
        </StyleWrapperDatePicker>
    );

    if (viewType === CALENDAR_VIEW_TYPE.DAY_VIEW) {
        return <DatePickerStyled
            onChange={onChangeDate}
            inputReadOnly
            clearIcon={false}
            value={value?.startTime}
            suffixIcon={false}
            bordered={false}
            inputRender={(props: React.InputHTMLAttributes<HTMLInputElement>) => {
                const dateValue = dayjs(props?.value as string);
                const isToday = dateValue.isSame(dayjs(), 'day');
                const timeDisplay = isToday
                    ? 'Today, ' + dateValue.format('MM-DD-YYYY')
                    : dateValue.format('ddd, MM-DD-YYYY');
                return (
                    <div {...props} className='input-group'>
                        <span>{timeDisplay}</span>
                        <img src={calendar_icon} className='calendar_icon' style={{ width: 32, height: 32 }} />
                    </div>
                );
            }}
        />;
    }
    if (viewType === CALENDAR_VIEW_TYPE.WEEK_VIEW || viewType === CALENDAR_VIEW_TYPE.TWO_WEEKS) {
        return <RangePickerStyled
            panelRender={panelRender}
            className='range-picker-custom'
            value={[value?.startTime || null, value?.endTime || null]}
            onChange={onChangeRange}
            inputReadOnly
            clearIcon={false}
            bordered={false}
            suffixIcon={<img src={calendar_icon} className='calendar_icon' style={{ width: 32, height: 32 }} />}
            separator={<span>-</span>}
            format={DATE_FORMAT}
            renderExtraFooter={() => <></>}
        />;
    }
    if (viewType === CALENDAR_VIEW_TYPE.MONTH_VIEW) {
        return <DatePickerStyled
            onChange={onChangeDate}
            inputReadOnly
            clearIcon={false}
            value={value?.startTime}
            suffixIcon={false}
            bordered={false}
            picker='month'
            format={DATE_FORMAT}
            inputRender={(props: React.InputHTMLAttributes<HTMLInputElement>) => {
                const dateValue = dayjs(props?.value as string);
                return (
                    <div {...props} className='input-group'>
                        <span>{dateValue.format('MMM ,YYYY')}</span>
                        <img src={calendar_icon} className='calendar_icon' style={{ width: 32, height: 32 }} />
                    </div>
                );
            }}
        />;
    }

    return <div>
        {viewType}
    </div>;
};

export default DatePickerByTypeView;

const DatePickerStyled = styled(AntdDatePicker)`
    .input-group {
        display: flex;
        align-items: center;
        gap: 16px;
        span {
            color: #1D2129;
            font-size: 1.5rem;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            white-space: nowrap;
        }
    }
`;

const RangePickerStyled = styled(RangePicker)`
    color: #1D2129;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    white-space: nowrap;
    .ant-picker{
        width: unset !important;
        padding: 2px 10px 2px 0px;
    }
    .ant-picker .ant-picker-input {
    position: unset !important;
    display: unset !important;
    align-items: unset !important;
    width: unset !important;
    }
    .ant-picker .ant-picker-input input {
        color: #1D2129 ;
        text-align: right;
        width: 6.5rem;
        font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';
        font-size: 1rem;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .ant-picker-focused .ant-picker-active-bar {
        display: none;
    }
    .ant-picker-focused .ant-picker-input-placeholder input {
        color: #acacac !important;
    }
    .ant-picker .ant-picker-suffix {
        padding-left: 1rem;
    }
    .ant-picker-suffix {
            margin: 0;
            padding: 0;
        }
        .ant-picker-range-separator {
            color: #1D2129;
            font-size: 1.5rem;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            text-align: center;
        }
        .ant-picker-input input {
            width: 10rem;
            color: #1D2129;
            font-size: 1.5rem;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            text-align: center;
        }
`;
const StyleWrapperDatePicker = styled.div`
    .ant-picker-panels > *:first-child button.ant-picker-header-next-btn {
    visibility: visible !important;
  }
  
  .ant-picker-panels > *:first-child button.ant-picker-header-super-next-btn {
    visibility: visible !important;
  }
  
  .ant-picker-panels > *:last-child {
    display: none;
  }
  
  .ant-picker-panel-container, .ant-picker-footer {
    width: 280px !important;
  }
  
  .ant-picker-footer-extra > div {
    flex-wrap: wrap !important; 
  }
  `;
